import {
  Accordion as BAccordion,
  AccordionProps,
  AccordionHeaderProps,
  AccordionCollapseProps,
  AccordionItemProps,
  useAccordionButton,
} from 'react-bootstrap';
import React from 'react';

const Container = ({ ...props }: React.PropsWithChildren<AccordionProps>) => {
  return <BAccordion {...props}>{props.children}</BAccordion>;
};

const Item = ({ ...props }: React.PropsWithChildren<AccordionItemProps>) => (
  <BAccordion.Item {...props}>{props.children}</BAccordion.Item>
);

function Header({ ...props }: React.PropsWithChildren<AccordionHeaderProps>) {
  return <BAccordion.Header {...props}>{props.children}</BAccordion.Header>;
}
function Body({ ...props }: React.PropsWithChildren) {
  return <BAccordion.Body {...props}>{props.children}</BAccordion.Body>;
}
function Collapse({
  ...props
}: React.PropsWithChildren<AccordionCollapseProps>) {
  return <BAccordion.Collapse {...props}>{props.children}</BAccordion.Collapse>;
}

const Accordion = {
  Container,
  Item,
  Header,
  Body,
  Collapse,
  useAccordionButton,
};
export default Accordion;
